module.exports = __webpack_public_path__ + "assets/img/login_bg_en.b257159c.png";